import { useTheme } from '@emotion/react';
import CloseIcon from '@mui/icons-material/Close';
import { Grid } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { sendRequest, serviceList } from 'src/utils';
import ButtonAction from '../../../components/Button.js/SaveButton';
import NumberInput from '../../../components/Input/NumberInput';
import TextInput from '../../../components/Input/TextInput';
import Loader from '../../../components/loader/loader';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

function BootstrapDialogTitle(props) {
    const { children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
}

BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired,
};
const RejectRequestTakeDeviceModal = ({ visible = false, callBackFunct, setVisible, data }) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const [reason, setReason] = useState(false);
    const [flagProcess, setFlagProcess] = useState(false);
    const flagRef = React.useRef(false);

    useEffect(() => {}, []);

    const handleClick = () => {
        if (flagRef.current === true) return;

        if (!reason) return toast.error(t('error.param'));

        flagRef.current = true;
        setFlagProcess(true);
        let InVal = [data.id, reason];
        sendRequest(serviceList.reject_request, InVal, actionResult, true, timeOutFunct, 40000);
    };
    const actionResult = (reqInfoMap, message) => {
        flagRef.current = false;
        setFlagProcess(false);
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error(message['proc_message']);
            return;
        } else {
            toast.success(message['proc_message']);
            callBackFunct && callBackFunct();
        }
    };
    const timeOutFunct = (reqInfo) => {
        flagRef.current = false;
        setFlagProcess(false);
        toast.error(t('error.time_out'));
    };
    return (
        <BootstrapDialog
            fullScreen={fullScreen}
            open={visible}
            aria-labelledby="customized-dialog-title"
            PaperProps={{ component: 'div' }}
        >
            <BootstrapDialogTitle
                onClose={() => {
                    setVisible(!visible);
                }}
                id="customized-dialog-title"
            >
                {t('rejectQtyTake')}
            </BootstrapDialogTitle>
            <Loader loading={flagProcess} />
            <DialogContent dividers>
                <Grid container spacing={2}>
                    <Grid item style={{ width: '100%' }} xl={6} md={6} sm={6}>
                        <NumberInput label={t('qtyTake')} valueChange={data?.qty || 0} size="medium" disabled={true} />
                    </Grid>
                    <Grid item style={{ width: '100%' }} xl={6} md={6} sm={6}>
                        <NumberInput
                            label={t('qtyUpdate')}
                            valueChange={data?.qty_change_request || 0}
                            size="medium"
                            disabled={true}
                        />
                    </Grid>
                    <Grid item style={{ width: '100%' }} xl={12} md={12} sm={12}>
                        <TextInput
                            type="textarea"
                            size="medium"
                            label={t('reason')}
                            valueChange={reason}
                            getValue={setReason}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions style={{ padding: '12px 16px' }}>
                <ButtonAction
                    onClick={() => {
                        setVisible(!visible);
                    }}
                    type={'cancel'}
                    title={t('cancel')}
                />
                <ButtonAction onClick={handleClick} type={'save'} icon="save" title={t('save')} />
            </DialogActions>
        </BootstrapDialog>
    );
};

export default RejectRequestTakeDeviceModal;
